import "flatpickr/dist/themes/material_blue.css";
import "../../../assets/scss/datatables.scss";

import * as confirmAction from "../../../store/confirm/action";
import * as loadingAction from "../../../store/loading/action";
import * as messageAction from "../../../store/message/action";

import {
    Button,
    Card,
    CardBody,
    CardTitle,
    Col,
    Container,
    Form,
    FormGroup,
    Input,
    InputGroup,
    Label,
    Modal,
    Nav,
    NavItem,
    NavLink,
    Row,
    TabContent,
    TabPane,
    Table,
} from "reactstrap";
import {
    GET_REPORT_GAS_COMPOSITION,
    GET_ACCOUNT,
    GET_RP_GC_DAILY_REPORT,
    SAVE_RP_GC_DAILY_REPORT,

} from "../../../helpers/url_api_constant";
import { Link, useHistory, useParams } from "react-router-dom";
import React, { createRef, useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { getPermission, getUserToken } from "../../../helpers/auth_helper";
import { post, postUpload } from "../../../helpers/api_helper";

import BootstrapTable from "react-bootstrap-table-next";
import Flatpickr from "react-flatpickr";
import OverButton from "../../../components/Custom/Overbutton";
// import OveruseByContact from "./OveruseByContact";
import PropTypes from "prop-types";
import Select from "react-select";
// import TableFour from "./TableFour";
// import TableOne from "./TableOne";
// import TableThree from "./TableThree";
// import TableTwo from "./TableTwo";
import logoPttColor from "../../../assets/images/PTT_LogoColor.png";
import moment from "moment";
import paginationFactory from "react-bootstrap-table2-paginator";
//i18n
import { withTranslation } from "react-i18next";

function GCNameDailyDetail(props) {

    function numberFormat(number, digit = 2) {
        if (number === null || number === "null" || number === "") return "";
        function isFloat(n) {
            return Number(n) === n && n % 1 !== 0;
        }
        if (isFloat(number))
            return parseFloat(number.toFixed(digit)).toLocaleString(undefined, {
                minimumFractionDigits: digit,
            });
        return parseFloat(number).toLocaleString(undefined, {
            minimumFractionDigits: digit,
        });
    }

    let history = useHistory();
    let { pid } = useParams();

    // const tpaDailyReducer = useSelector(reducer => reducer.TPADailyReport);

    const dispatch = useDispatch();
    const permission = getPermission();
    const searchObj = { PID: pid };
    // const createObj = {};
    const gcNameDailyPID = { PID: pid };
    const model = {
        PID: pid,
        GCDAILY_REV: "",
        TPADAILY_APPROVE: null,
        TPADAILY_LEVEL: null,
        GCDAILY_DATE: "",
        STATUS_EMAIL: 0,
    }
    const [modelDevice, setModelDevice] = useState(model);

    const [listPipeLine34, setListPipeLine34] = useState([]);
    const [listPipeLine36, setListPipeLine36] = useState([]);
    const [listKhanom, setListKhanom] = useState([]);
    const [listPipeLine42, setListPipeLine42] = useState([]);
    const [listMyanmarPipeLine, setListMyanmarPipeLine] = useState([]);

    // const [createModel, setCreateModel] = useState(createObj);
    const [searchModel, setSearchModel] = useState(searchObj);
    const [pageAdd, setPageAdd] = useState(false);

    const [listUser, setListUser] = useState([]);
    const [dropDownUser, setDropDownUser] = useState(null);
    // const [dropDownShift, setDropDownShift] = useState(null);

    //onInit//
    useEffect(function () {
        fetchData();
        // getDataUser();
        // resetSearch();
        // resetModel();
    }, []);
    //onInit//

    const SelectStyle = {
        option: (provided, { data, isDisabled, isFocused, isSelected }) => ({
            ...provided,
            ...isFocused && ({ backgroundColor: '#2E3460' })
        }),
    }

    const resetModel = () => {
        // setCreateModel(createObj);
        // setDropDownUser(null);
    };

    const gotoMainMenu = () => {
        history.push({
            pathname: "/gas-composition-report", state: {  // location state
                goBack: true,
            },
        });
    };

    const compare = (a, b) => {
        // console.log(a, b);
        if (a.ALIAS_NAME < b.ALIAS_NAME) {
            return -1;
        }
        if (a.ALIAS_NAME > b.ALIAS_NAME) {
            return 1;
        }
        return 0;
    }

    // useEffect(() => {
    //     // console.log(tpaDailyReducer);
    // }, [tpaDailyReducer]);

    //Function CURL
    const resetSearch = () => {
        setSearchModel(searchObj);
        // fetchData(searchObj);
        getDataUser();
    };

    const onSearch = () => {
        // console.log(searchModel);
        fetchData(searchModel);
    };

    const handleSelectDropDownUser = selected => {
        setDropDownUser(selected);
    };

    // const handleSelectDropDownShift = selected => {
    //     setDropDownShift(selected);
    // };

    // const getDataUser = async () => {
    //     dispatch(loadingAction.showLoading());
    //     try {
    //         let res = await post(GET_ACCOUNT, { UNITNAME: "บค.", IS_LEADER_SHIFT: false });
    //         console.log(res);
    //         // setListUser(res.data.AccountList.sort(compare).map((obj) => ({ label: obj.DISPLAY_NAME, value: obj.LOGIN_NAME })));
    //         let listDataUser = res.data.AccountList.sort(compare).map((obj) => ({ label: obj.DISPLAY_NAME, value: obj.LOGIN_NAME }));
    //         setListUser(listDataUser);
    //         console.log(modelDevice);

    //         if (modelDevice.TPADAILY_APPROVE == null) {
    //             alert('case1');
    //             setDropDownUser(null);
    //             // setDropDownShift(listShift[0]);
    //         } else {
    //             alert('case2');
    //             // console.log(listDataUser);
    //             // console.log(res.data.rpTPADailyList[0].TPADAILY_APPROVE);
    //             // console.log(listUser.find(obj =>
    //             //     obj.value == res.data.rpTPADailyList[0].TPADAILY_APPROVE
    //             // ));
    //             let user = listDataUser.find(obj => obj.value == modelDevice.TPADAILY_APPROVE);
    //             // console.log(user);
    //             setDropDownUser(user);
    //             // setDropDownShift(listShift[0]);
    //         }
    //     } catch (error) {
    //         dispatch(messageAction.showMessage(error.message));
    //     }
    //     dispatch(loadingAction.hideLoading());
    // };

    const fetchData = async () => {
        dispatch(loadingAction.showLoading());
        try {

            let [res, dataDetail, dataUser] = await Promise.all([
                post(GET_REPORT_GAS_COMPOSITION, { GCDAILY_PID: pid }),
                post(GET_RP_GC_DAILY_REPORT, { PID: pid }),
                post(GET_ACCOUNT, { UNITNAME: "บค.", IS_LEADER_SHIFT: false }),
            ])
            // console.log(dataDetail);
            setListPipeLine34(res.data.pipeline34);
            setListPipeLine36(res.data.pipeline36);
            setListKhanom(res.data.khanom);
            setListPipeLine42(res.data.pipeline42);
            setListMyanmarPipeLine(res.data.myanmarPipeline);
            // console.log(dataDetail)

            let detail = dataDetail.data.rpGCDailyList[0];
            setModelDevice({
                ...detail, TPADAILY_LEVEL: detail.TPADAILY_LEVEL == null ? "" : detail.TPADAILY_LEVEL
            });
            // setModelDevice(detail);

            let listDataUser = dataUser.data.AccountList.sort(compare).map((obj) => ({ label: obj.DISPLAY_NAME, value: obj.LOGIN_NAME, shift: obj.SHOW_SHIFT }));
            setListUser(listDataUser);

            if (detail.TPADAILY_APPROVE == null) {
                setDropDownUser(null);
            } else {
                let user = listDataUser.find(obj => obj.value == detail.TPADAILY_APPROVE);
                setDropDownUser(user);
            }

        } catch (error) {
            dispatch(messageAction.showMessage(error.message));
        }
        dispatch(loadingAction.hideLoading());
    };

    const validateForm = () => {
        let bResult = true;

        let element = document.querySelectorAll(".form-require")
        element.forEach(el => {
            if (el.classList.contains("is-invalid")) {
                el.classList.remove('is-invalid')
            }
        }
        );

        if (modelDevice.TPADAILY_APPROVE == null || modelDevice.TPADAILY_APPROVE == "" || modelDevice.TPADAILY_APPROVE == undefined) {
            document.getElementById("GC_APPROVE").classList.add('is-invalid');
            bResult = false;
        }

        return bResult;

    };

    // useEffect(() => {
    //     console.log(modelDevice);
    // }, [modelDevice]);

    const handlerSaveGCDailyReport = async () => {
        if (validateForm()) {
            dispatch(loadingAction.showLoading());
            try {
                let res = await post(SAVE_RP_GC_DAILY_REPORT, modelDevice);
                if (res.resultCode == 200) {
                    dispatch(messageAction.showMessage("Save success."));
                } else {
                    dispatch(messageAction.showMessage(res.resultDescription));
                }
            } catch (error) {
                dispatch(messageAction.showMessage(error.message));
            }
            dispatch(loadingAction.hideLoading());
        } else {
            dispatch(messageAction.showMessage("Please complete the sender information."));
        }
    };

    useEffect(function () {
        let TPADAILY_APPROVE = dropDownUser != null ? dropDownUser.value : null;
        let TPADAILY_LEVEL = dropDownUser != null ? dropDownUser.shift : "";
        setModelDevice(preVent => ({
            ...preVent, TPADAILY_APPROVE: TPADAILY_APPROVE, TPADAILY_LEVEL: TPADAILY_LEVEL,
        }));
    }, [dropDownUser]);

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Row>
                        <Col xl="12">
                            <Card>
                                <CardBody>
                                    <div className="page-title-box d-sm-flex align-items-center justify-content-between pb-0">
                                        <h1 className="mb-sm-0 font-size-20">
                                            Gas Composition Daily ( Detail )
                                        </h1>
                                        <div className="page-title-right">
                                            <ol className="breadcrumb m-0">
                                                <li className="breadcrumb-item">
                                                    <Link to="#" style={{ color: "#556ee6" }}>
                                                        Report
                                                    </Link>
                                                </li>
                                                <li className="breadcrumb-item">
                                                    <Link to="/gas-composition-report" style={{ color: "#556ee6" }}>
                                                        Gas Composition Daily
                                                    </Link>
                                                </li>
                                                <li className="breadcrumb-item active">
                                                    Gas Composition Daily ( Detail )
                                                </li>
                                            </ol>
                                        </div>
                                    </div>

                                    <hr />

                                    <Row>
                                        <Col
                                            sm="6"
                                            className="d-flex align-items-center justify-content-start"
                                        >
                                            <span style={{ fontSize: "17px", color: "#FFFFFF" }}>Report Date : </span>&nbsp;&nbsp;<span style={{ fontSize: "17px", color: "#556ee6" }}>{modelDevice.GCDAILY_DATE == undefined ? "" : moment(modelDevice.GCDAILY_DATE).locale('en')
                                                .format(
                                                    "DD/MM/YYYY"
                                                )}</span>
                                          
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            <span style={{ fontSize: "17px", color: "#FFFFFF" }}>Summary Report Revision : </span>&nbsp;&nbsp;<span style={{ fontSize: "17px", color: "#556ee6" }}>{modelDevice.GCDAILY_REV}</span>
                                        </Col>
                                        <Col
                                            sm="6"
                                            className="d-flex align-items-center justify-content-end"
                                        >
                                            <div className="d-grid gap-2 d-md-block">
                                                <Button
                                                    onClick={() => gotoMainMenu()}
                                                    // className="btn-rounded"
                                                    color="secondary"
                                                    className="mt-2 mb-2"
                                                >
                                                    <i className="fas fa-angle-double-left"></i>
                                                    &nbsp; Back
                                                </Button>
                                            </div>
                                        </Col>

                                    </Row>

                                    <Row>
                                        <label className="d-sm-flex align-items-center justify-content-center mt-2" style={{ fontSize: "18px", color: "#FFFFFF" }}>
                                            เรียน   ยรก.,ยยก.,ยขก.,ทผก.,ปกต.1,ปกต.2,ปกต.3,บคต.,วรต.,ผจ.วผ.,ผจ.กผ.,ผจ.คพ.,ผจ.ปข.,ผจ.ปต.,ผจ.ปผ.,ผจ.วบ.,ผจ.บค.,ผจ.ปร.,ผจ.คภ.,ผจ.ปท.8 &nbsp;&nbsp;
                                        </label>
                                    </Row>

                                    <Row>
                                        <label className="d-sm-flex align-items-center justify-content-start mt-1 ms-2" style={{ fontSize: "18px", color: "#FFFFFF" }}>
                                            ส่วน บค./บคต. ขอส่งประมาณการ COMPOSITION ของก๊าซในท่อในทะเลฝั่งตะวันออกและฝั่งตะวันตก  ดังนี้
                                        </label>
                                    </Row>

                                    <Row>
                                        <label className="d-sm-flex align-items-center justify-content-start mt-3 ms-2" style={{ fontSize: "18px", color: "#FFFF00" }}>
                                            PIPELINE 34&#34;
                                        </label>
                                    </Row>

                                    <Row>
                                        <div className="table">
                                            {/* hover-table-highlight */}
                                            <Table className="table table-bordered mb-0">
                                                <thead>
                                                    {/* <tr>
                                                        <th colSpan={2} style={{ backgroundColor: "#556ee64a", color: "#FFFFFF", textAlign: "center", width: "100%" }}>ข้อมูลปริมาณ Shrinkage Gas และตัวแปรอื่น ๆ(หน่วย : MMBTU)</th>
                                                    </tr> */}
                                                    <tr>
                                                        <th style={{ backgroundColor: "#667eef85", color: "#FFFFFF", textAlign: "center", width: "10%" }}>COMPOSITION GAS</th>
                                                        <th style={{ backgroundColor: "#667eef85", color: "#FFFFFF", textAlign: "center", width: "9%" }}>ERW</th>
                                                        <th style={{ backgroundColor: "#667eef85", color: "#FFFFFF", textAlign: "center", width: "9%" }}>BPT</th>
                                                        <th style={{ backgroundColor: "#667eef85", color: "#FFFFFF", textAlign: "center", width: "9%" }}>STN</th>
                                                        <th style={{ backgroundColor: "#667eef85", color: "#FFFFFF", textAlign: "center", width: "9%" }}>FUN 34</th>
                                                        <th style={{ backgroundColor: "#667eef85", color: "#FFFFFF", textAlign: "center", width: "9%" }}>GBN 34</th>
                                                        <th style={{ backgroundColor: "#667eef85", color: "#38B4FF", textAlign: "center", width: "9%" }}>GAS MIX 36&#34;</th>
                                                        <th style={{ backgroundColor: "#667eef85", color: "#38B4FF", textAlign: "center", width: "9%" }}>GAS MIX 42&#34;</th>
                                                        <th style={{ backgroundColor: "#667eef85", color: "#FFFFFF", textAlign: "center", width: "9%" }}>PLT</th>
                                                        <th style={{ backgroundColor: "#667eef85", color: "#38B4FF", textAlign: "center", width: "9%" }}>GAS MIX 34&#34;</th>
                                                        <th style={{ backgroundColor: "#667eef85", color: "#38B4FF", textAlign: "center", width: "9%" }}>&apos;RY 34&#34;</th>
                                                    </tr>
                                                </thead>
                                                <tbody style={{ color: "#FFFFFF", textAlign: "center" }}>
                                                    {/* {tableThreeModelList.map((value, index) => (<RenderList key={index} data={value} indexlist={index + 1} />))} */}


                                                    {listPipeLine34.map((value, index) => {

                                                        if (value.COMPOSITION_GAS == "HHV(DRY)") {
                                                            return (
                                                                <tr key={index}>
                                                                    <td colSpan={9} style={{ textAlign: "left" }}>{value.COMPOSITION_GAS}</td>
                                                                    <td>{numberFormat(value.GAS_MIX_34, 2)}</td>
                                                                    <td>{numberFormat(value.RY_34, 2)}</td>
                                                                </tr>)
                                                        } else if (value.COMPOSITION_GAS == "Specific Gravity ( at 14.73 psi, 60 F)") {
                                                            return (
                                                                <tr key={index}>
                                                                    <td colSpan={10} style={{ textAlign: "left" }}>{value.COMPOSITION_GAS}</td>
                                                                    {/* <td></td> */}
                                                                    <td>{numberFormat(value.RY_34, 2)}</td>
                                                                </tr>)
                                                        } else {
                                                            return (
                                                                <tr key={index}>
                                                                    <td>{value.COMPOSITION_GAS}</td>
                                                                    <td>{numberFormat(value.ERW, 2)}</td>
                                                                    <td>{numberFormat(value.BPT, 2)}</td>
                                                                    <td>{numberFormat(value.STN, 2)}</td>
                                                                    <td>{numberFormat(value.FUN_34, 2)}</td>
                                                                    <td>{numberFormat(value.GBN_34, 2)}</td>
                                                                    <td>{numberFormat(value.GAS_MIX_36, 2)}</td>
                                                                    <td>{numberFormat(value.GAS_MIX_42, 2)}</td>
                                                                    <td>{numberFormat(value.PLT, 2)}</td>
                                                                    <td>{numberFormat(value.GAS_MIX_34, 2)}</td>
                                                                    <td>{numberFormat(value.RY_34, 2)}</td>
                                                                </tr>)
                                                        }
                                                    })
                                                    }
                                                </tbody>
                                            </Table>
                                        </div>
                                    </Row>

                                    <Row>
                                        <label className="d-sm-flex align-items-center justify-content-start mt-3 ms-2" style={{ fontSize: "18px", color: "#FFFF00" }}>
                                            PIPELINE 36&#34;
                                        </label>
                                    </Row>

                                    <Row>
                                        <div className="table">
                                            {/* hover-table-highlight */}
                                            <Table className="table table-bordered mb-0">
                                                <thead>
                                                    {/* <tr>
                                                        <th colSpan={2} style={{ backgroundColor: "#556ee64a", color: "#FFFFFF", textAlign: "center", width: "100%" }}>ข้อมูลปริมาณ Shrinkage Gas และตัวแปรอื่น ๆ(หน่วย : MMBTU)</th>
                                                    </tr> */}
                                                    <tr>
                                                        <th style={{ backgroundColor: "#667eef85", color: "#FFFFFF", textAlign: "center", width: "19%" }}>COMPOSITION GAS</th>
                                                        <th style={{ backgroundColor: "#667eef85", color: "#FFFFFF", textAlign: "center", width: "9%" }}>GBN 36</th>
                                                        <th style={{ backgroundColor: "#667eef85", color: "#FFFFFF", textAlign: "center", width: "9%" }}>FUN 36</th>
                                                        <th style={{ backgroundColor: "#667eef85", color: "#38B4FF", textAlign: "center", width: "9%" }}>GAS MIX 34&#34;</th>
                                                        <th style={{ backgroundColor: "#667eef85", color: "#38B4FF", textAlign: "center", width: "9%" }}>GAS MIX 42&#34;</th>
                                                        <th style={{ backgroundColor: "#667eef85", color: "#FFFFFF", textAlign: "center", width: "9%" }}>SPL</th>
                                                        <th style={{ backgroundColor: "#667eef85", color: "#FFFFFF", textAlign: "center", width: "9%" }}>NPL</th>
                                                        <th style={{ backgroundColor: "#667eef85", color: "#FFFFFF", textAlign: "center", width: "9%" }}>BEN</th>
                                                        <th style={{ backgroundColor: "#667eef85", color: "#38B4FF", textAlign: "center", width: "9%" }}>GAS MIX 36&#34;</th>
                                                        <th style={{ backgroundColor: "#667eef85", color: "#38B4FF", textAlign: "center", width: "9%" }}>&apos;RY 36&#34;</th>
                                                    </tr>
                                                </thead>
                                                <tbody style={{ color: "#FFFFFF", textAlign: "center" }}>
                                                    {listPipeLine36.map((value, index) => {
                                                        if (value.COMPOSITION_GAS == "HHV(DRY)") {
                                                            return (
                                                                <tr key={index}>
                                                                    <td colSpan={8} style={{ textAlign: "left" }}>{value.COMPOSITION_GAS}</td>
                                                                    <td>{numberFormat(value.GAS_MIX_36, 2)}</td>
                                                                    <td>{numberFormat(value.RY_36, 2)}</td>
                                                                </tr>)
                                                        } else if (value.COMPOSITION_GAS == "Specific Gravity ( at 14.73 psi, 60 F)") {
                                                            return (
                                                                <tr key={index}>
                                                                    <td colSpan={9} style={{ textAlign: "left" }}>{value.COMPOSITION_GAS}</td>
                                                                    <td>{numberFormat(value.RY_36, 2)}</td>
                                                                </tr>)
                                                        } else {
                                                            return (
                                                                <tr key={index} >
                                                                    <td>{value.COMPOSITION_GAS}</td>
                                                                    <td>{numberFormat(value.GBN_36, 2)}</td>
                                                                    <td>{numberFormat(value.FUN_36, 2)}</td>
                                                                    <td>{numberFormat(value.GAS_MIX_34, 2)}</td>
                                                                    <td>{numberFormat(value.GAS_MIX_42, 2)}</td>
                                                                    <td>{numberFormat(value.S_PAILIN, 2)}</td>
                                                                    <td>{numberFormat(value.N_PAILIN, 2)}</td>
                                                                    <td>{numberFormat(value.BEN, 2)}</td>
                                                                    <td>{numberFormat(value.GAS_MIX_36, 2)}</td>
                                                                    <td>{numberFormat(value.RY_36, 2)}</td>
                                                                </tr>
                                                            )
                                                        }
                                                    })}

                                                </tbody>
                                            </Table>
                                        </div>
                                    </Row>

                                    <Row>
                                        <label className="d-sm-flex align-items-center justify-content-start mt-3 ms-2" style={{ fontSize: "18px", color: "#FFFF00" }}>
                                            KHANOM
                                        </label>
                                    </Row>

                                    <Row>
                                        <div className="table">
                                            {/* hover-table-highlight */}
                                            <Table className="table table-bordered mb-0">
                                                <thead>
                                                    {/* <tr>
                                                        <th colSpan={2} style={{ backgroundColor: "#556ee64a", color: "#FFFFFF", textAlign: "center", width: "100%" }}>ข้อมูลปริมาณ Shrinkage Gas และตัวแปรอื่น ๆ(หน่วย : MMBTU)</th>
                                                    </tr> */}
                                                    <tr>
                                                        <th style={{ backgroundColor: "#667eef85", color: "#FFFFFF", textAlign: "center", width: "25%" }}>COMPOSITION GAS</th>
                                                        <th style={{ backgroundColor: "#667eef85", color: "#FFFFFF", textAlign: "center", width: "15%" }}>GBN 24</th>
                                                        <th style={{ backgroundColor: "#667eef85", color: "#FFFFFF", textAlign: "center", width: "15%" }}>FUN 24</th>
                                                        <th style={{ backgroundColor: "#667eef85", color: "#38B4FF", textAlign: "center", width: "15%" }}>GAS MIX 34&#34;</th>
                                                        <th style={{ backgroundColor: "#667eef85", color: "#38B4FF", textAlign: "center", width: "15%" }}>GAS MIX 42&#34;</th>
                                                        <th style={{ backgroundColor: "#667eef85", color: "#38B4FF", textAlign: "center", width: "15%" }}>To KN</th>
                                                    </tr>
                                                </thead>
                                                <tbody style={{ color: "#FFFFFF", textAlign: "center" }}>

                                                    {listKhanom.map((value, index) => {
                                                        if (value.COMPOSITION_GAS == "HHV(DRY)") {
                                                            return (
                                                                <tr key={index}>
                                                                    <td colSpan={4} style={{ textAlign: "left" }}>{value.COMPOSITION_GAS}</td>
                                                                    <td></td>
                                                                    <td>{numberFormat(value.TO_KN, 2)}</td>
                                                                </tr>
                                                            )
                                                        } else if (value.COMPOSITION_GAS == "Specific Gravity ( at 14.73 psi, 60 F)") {
                                                            return (
                                                                <tr key={index}>
                                                                    <td colSpan={5} style={{ textAlign: "left" }}>{value.COMPOSITION_GAS}</td>
                                                                    <td>{numberFormat(value.TO_KN, 2)}</td>
                                                                </tr>
                                                            )
                                                        } else {
                                                            return (
                                                                <tr key={index} >
                                                                    <td>{value.COMPOSITION_GAS}</td>
                                                                    <td>{numberFormat(value.GBN_24, 2)}</td>
                                                                    <td>{numberFormat(value.FUN_24, 2)}</td>
                                                                    <td>{numberFormat(value.GAS_MIX_34, 2)}</td>
                                                                    <td>{numberFormat(value.GAS_MIX_42, 2)}</td>
                                                                    <td>{numberFormat(value.TO_KN, 2)}</td>
                                                                </tr>
                                                            )
                                                        }
                                                    })}
                                                </tbody>
                                            </Table>
                                        </div>
                                    </Row>

                                    <Row>
                                        <label className="d-sm-flex align-items-center justify-content-start mt-3 ms-2" style={{ fontSize: "18px", color: "#FFFF00" }}>
                                            PIPELINE 42&#34;
                                        </label>
                                    </Row>

                                    <Row>
                                        <div className="table">
                                            {/* hover-table-highlight */}
                                            <Table className="table table-bordered mb-0">
                                                <thead>
                                                    {/* <tr>
                                                        <th colSpan={2} style={{ backgroundColor: "#556ee64a", color: "#FFFFFF", textAlign: "center", width: "100%" }}>ข้อมูลปริมาณ Shrinkage Gas และตัวแปรอื่น ๆ(หน่วย : MMBTU)</th>
                                                    </tr> */}
                                                    <tr>
                                                        <th style={{ backgroundColor: "#667eef85", color: "#FFFFFF", textAlign: "center", width: "19%" }}>COMPOSITION GAS (MOLE %)</th>
                                                        <th style={{ backgroundColor: "#667eef85", color: "#FFFFFF", textAlign: "center", width: "9%" }}>ATH</th>
                                                        <th style={{ backgroundColor: "#667eef85", color: "#FFFFFF", textAlign: "center", width: "9%" }}>GBS</th>
                                                        <th style={{ backgroundColor: "#667eef85", color: "#FFFFFF", textAlign: "center", width: "9%" }}>A18_2</th>
                                                        <th style={{ backgroundColor: "#667eef85", color: "#FFFFFF", textAlign: "center", width: "9%" }}>B17</th>
                                                        <th style={{ backgroundColor: "#667eef85", color: "#38B4FF", textAlign: "center", width: "9%" }}>GAS MIX 34&#34;</th>
                                                        <th style={{ backgroundColor: "#667eef85", color: "#38B4FF", textAlign: "center", width: "9%" }}>GAS MIX 36&#34;</th>
                                                        <th style={{ backgroundColor: "#667eef85", color: "#FFFFFF", textAlign: "center", width: "9%" }}>PLT2 To 42&#34;</th>
                                                        <th style={{ backgroundColor: "#667eef85", color: "#38B4FF", textAlign: "center", width: "9%" }}>GAS MIX 42&#34;</th>
                                                        <th style={{ backgroundColor: "#667eef85", color: "#38B4FF", textAlign: "center", width: "9%" }}>GAS MIX to RY42&#34;</th>
                                                    </tr>
                                                </thead>
                                                <tbody style={{ color: "#FFFFFF", textAlign: "center" }}>
                                                    {listPipeLine42.map((value, index) => {
                                                        if (value.COMPOSITION_GAS == "HHV(DRY)") {
                                                            return (
                                                                <tr key={index}>
                                                                    <td colSpan={8} style={{ textAlign: "left" }}>{value.COMPOSITION_GAS}</td>
                                                                    <td>{numberFormat(value.GAS_MIX_42, 2)}</td>
                                                                    <td>{numberFormat(value.GAS_MIX_TO_RY42, 2)}</td>
                                                                </tr>
                                                            )
                                                        } else if (value.COMPOSITION_GAS == "Specific Gravity ( at 14.73 psi, 60 F)") {
                                                            return (
                                                                <tr key={index}>
                                                                    <td colSpan={9} style={{ textAlign: "left" }}>{value.COMPOSITION_GAS}</td>
                                                                    <td>{numberFormat(value.GAS_MIX_TO_RY42, 2)}</td>
                                                                </tr>
                                                            )
                                                        } else {
                                                            return (
                                                                <tr key={index} >
                                                                    <td>{value.COMPOSITION_GAS}</td>
                                                                    <td>{numberFormat(value.ARTHIT, 2)}</td>
                                                                    <td>{numberFormat(value.GBS, 2)}</td>
                                                                    <td>{numberFormat(value.JDA_A18_DP2, 2)}</td>
                                                                    <td>{numberFormat(value.JDA_B17, 2)}</td>
                                                                    <td>{numberFormat(value.GAS_MIX_34, 2)}</td>
                                                                    <td>{numberFormat(value.GAS_MIX_36, 2)}</td>
                                                                    <td>{numberFormat(value.PLT2_TO_42, 2)}</td>
                                                                    <td>{numberFormat(value.GAS_MIX_42, 2)}</td>
                                                                    <td>{numberFormat(value.GAS_MIX_TO_RY42, 2)}</td>
                                                                </tr>
                                                            )
                                                        }
                                                    })}
                                                </tbody>
                                            </Table>
                                        </div>
                                    </Row>

                                    <Row>
                                        <label className="d-sm-flex align-items-center justify-content-start mt-3 ms-2" style={{ fontSize: "18px", color: "#FFFF00" }}>
                                            MYANMAR PIPELINE
                                        </label>
                                    </Row>

                                    <Row>
                                        <div className="table">
                                            {/* hover-table-highlight */}
                                            <Table className="table table-bordered mb-0">
                                                <thead>
                                                    {/* <tr>
                                                        <th colSpan={2} style={{ backgroundColor: "#556ee64a", color: "#FFFFFF", textAlign: "center", width: "100%" }}>ข้อมูลปริมาณ Shrinkage Gas และตัวแปรอื่น ๆ(หน่วย : MMBTU)</th>
                                                    </tr> */}
                                                    <tr>
                                                        <th style={{ backgroundColor: "#667eef85", color: "#FFFFFF", textAlign: "center", width: "24%" }}>COMPOSITION GAS (MOLE %)</th>
                                                        <th style={{ backgroundColor: "#667eef85", color: "#FFFFFF", textAlign: "center", width: "19%" }}>YADANA</th>
                                                        <th style={{ backgroundColor: "#667eef85", color: "#FFFFFF", textAlign: "center", width: "19%" }}>YETAGUN</th>
                                                        <th style={{ backgroundColor: "#667eef85", color: "#FFFFFF", textAlign: "center", width: "19%" }}>ZAWTIKA</th>
                                                        <th style={{ backgroundColor: "#667eef85", color: "#38B4FF", textAlign: "center", width: "19%" }}>GAS MIX to 42&#34;</th>
                                                    </tr>
                                                </thead>
                                                <tbody style={{ color: "#FFFFFF", textAlign: "center" }}>
                                                    {/* {tableThreeModelList.map((value, index) => (<RenderList key={index} data={value} indexlist={index + 1} />))} */}
                                                    {listMyanmarPipeLine.map((value, index) => {
                                                        if (value.COMPOSITION_GAS == "HHV(DRY)") {
                                                            return (
                                                                <tr key={index}>
                                                                    <td colSpan={3} style={{ textAlign: "left" }}>{value.COMPOSITION_GAS}</td>
                                                                    <td></td>
                                                                    <td>{numberFormat(value.GAS_MIX_TO_42, 2)}</td>
                                                                </tr>
                                                            )
                                                        } else if (value.COMPOSITION_GAS == "Specific Gravity ( at 14.73 psi, 60 F)") {
                                                            return (
                                                                <tr key={index}>
                                                                    <td colSpan={4} style={{ textAlign: "left" }}>{value.COMPOSITION_GAS}</td>
                                                                    <td>{numberFormat(value.GAS_MIX_TO_42, 2)}</td>
                                                                </tr>
                                                            )
                                                        } else {
                                                            return (
                                                                <tr key={index} >
                                                                    <td>{value.COMPOSITION_GAS}</td>
                                                                    <td>{numberFormat(value.YADANA, 2)}</td>
                                                                    <td>{numberFormat(value.YETAGUN, 2)}</td>
                                                                    <td>{numberFormat(value.ZAWTIKA, 2)}</td>
                                                                    <td>{numberFormat(value.GAS_MIX_TO_42, 2)}</td>
                                                                </tr>
                                                            )
                                                        }
                                                    })}
                                                </tbody>
                                            </Table>
                                        </div>
                                    </Row>

                                    <Row>
                                        <Col sm="9">
                                            <label className="d-sm-flex align-items-center justify-content-start mt-2 ms-0" style={{ fontSize: "15px", color: "#FFFFFF" }}>
                                                <span style={{ fontSize: "16px", color: "#FF2F21", textDecoration: "underline" }}>หมายเหตุ </span>
                                                &nbsp;&nbsp;1.COMPOSITION ของ ERW , BPT , STN , FUN , PLT , N.PAILIN , S.PAILIN , BEN, PLT2, YADANA, YETAGUN และ ZAWTIKA ได้มาจากค่าเฉลี่ย วันที่
                                            </label>
                                        </Col>
                                        <Col sm="3">
                                            <label className="d-sm-flex align-items-center justify-content-start mt-2 ms-0" style={{ fontSize: "15px", color: "#FFDD03" }}>
                                                (Gas Day)&nbsp;&nbsp;
                                                <span style={{ fontSize: "15px", color: "#FF2F21" }}>{moment(modelDevice.GCDAILY_DATE).locale('th').add(543, 'year').add(-1, 'day').format("LL")}</span>
                                            </label>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col sm="9">
                                            <label className="d-sm-flex align-items-center justify-content-start mt-0 ms-5" style={{ fontSize: "15px", color: "#FFFFFF" }}>
                                                &nbsp;&nbsp;&nbsp;&nbsp; 2.COMPOSITION ของ GBN ได้มาจากค่าเฉลี่ย วันที่
                                            </label>
                                        </Col>
                                        <Col sm="3">
                                            <label className="d-sm-flex align-items-center justify-content-start mt-0 ms-0" style={{ fontSize: "15px", color: "#FFDD03" }}>
                                                (Gas Day - 1)&nbsp;&nbsp;
                                                <span style={{ fontSize: "15px", color: "#FF2F21" }}>{moment(modelDevice.GCDAILY_DATE).locale('th').add(543, 'year').add(-2, 'day').format("LL")}</span>
                                            </label>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col sm="9">
                                            <label className="d-sm-flex align-items-center justify-content-start mt-0 ms-5" style={{ fontSize: "15px", color: "#FFFFFF" }}>
                                                &nbsp;&nbsp;&nbsp;&nbsp; 3.COMPOSITION ของ ART, GBS ได้มาจากค่าเฉลี่ย วันที่
                                            </label>
                                        </Col>
                                        <Col sm="3">
                                            <label className="d-sm-flex align-items-center justify-content-start mt-0 ms-0" style={{ fontSize: "15px", color: "#FFDD03" }}>
                                                (Gas Day - 2)&nbsp;&nbsp;
                                                <span style={{ fontSize: "15px", color: "#FF2F21" }}>{moment(modelDevice.GCDAILY_DATE).locale('th').add(543, 'year').add(-3, 'day').format("LL")}</span>
                                            </label>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col sm="9">
                                            <label className="d-sm-flex align-items-center justify-content-start mt-0 ms-5" style={{ fontSize: "15px", color: "#FFFFFF" }}>
                                                &nbsp;&nbsp;&nbsp;&nbsp; 4.COMPOSITION ของ JDA-A18 DP2 และ JDA-B17 ได้มาจากค่าเฉลี่ย วันที่
                                            </label>
                                        </Col>
                                        <Col sm="3">
                                            <label className="d-sm-flex align-items-center justify-content-start mt-0 ms-0" style={{ fontSize: "15px", color: "#FFDD03" }}>
                                                (Gas Day - 3)&nbsp;&nbsp;
                                                <span style={{ fontSize: "15px", color: "#FF2F21" }}>{moment(modelDevice.GCDAILY_DATE).locale('th').add(543, 'year').add(-4, 'day').format("LL")}</span>
                                            </label>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <label className="d-sm-flex align-items-center justify-content-start mt-0 ms-5" style={{ fontSize: "15px", color: "#FFFFFF" }}>
                                            &nbsp;&nbsp;&nbsp;&nbsp; 5.ก๊าซจากท่อ 34,42 นิ้วใช้เวลาประมาณ 1 วัน ในการไหลจาก ECP ถึง โรงแยกก๊าซ จ.ระยอง
                                        </label>
                                    </Row>

                                    <Row>
                                        <label className="d-sm-flex align-items-center justify-content-start mt-0 ms-5" style={{ fontSize: "15px", color: "#FFFFFF" }}>
                                            &nbsp;&nbsp;&nbsp;&nbsp; 6.ก๊าซจากท่อ 36 นิ้วใช้เวลาประมาณ 1 วัน ในการไหลจาก ERP ถึง DPCU
                                        </label>
                                    </Row>

                                    <Row>
                                        <label className="d-sm-flex align-items-center justify-content-start mt-0 ms-5" style={{ fontSize: "15px", color: "#FFFFFF" }}>
                                            &nbsp;&nbsp;&nbsp;&nbsp; 7.ก๊าซจากท่อ 24 นิ้วใช้เวลาประมาณ 1 วัน ไหลจาก ERP ถึงโรงแยกก๊าซขนอม จ.นครศรีธรรมราช
                                        </label>
                                    </Row>

                                    <Row>
                                        <Col sm="8"></Col>
                                        <Col sm="4" className="mt-4">
                                            <FormGroup className="row">
                                                <Label className="col-sm-4 col-form-label d-flex align-items-center justify-content-end" style={{ fontSize: "16px", color: "#FFFFFF" }}>
                                                    ลงชื่อ
                                                </Label>
                                                <Col sm={8}>
                                                    <Select
                                                        id="GC_APPROVE"
                                                        placeholder=""
                                                        isClearable={true}
                                                        value={dropDownUser}
                                                        onChange={handleSelectDropDownUser}
                                                        options={listUser}
                                                        classNamePrefix="form-require select2-selection"
                                                        styles={SelectStyle}
                                                        isDisabled={permission.eGCN != true}
                                                    />
                                                </Col>
                                            </FormGroup>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col sm="9"></Col>
                                        <Col sm="3" className="mt-1">
                                            <Label className="col-form-label d-flex align-items-center justify-content-center ms-5" style={{ fontSize: "16px", color: "#FFFFFF" }}>
                                                พนักงานปฏิบัติการส่งก๊าซ
                                            </Label>
                                        </Col>
                                    </Row>
                                    <Row className="mt-3">
                                        <div className="d-flex align-items-center justify-content-end">
                                            {permission.eGCN && (
                                                <>
                                                    <Button
                                                        onClick={() => handlerSaveGCDailyReport()}
                                                        color="success"
                                                        className="btn w-md ms-2"
                                                    >
                                                        <i className="bx bx-save"> </i> &nbsp; Save
                                                    </Button>
                                                </>
                                            )}
                                        </div>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment >
    );
}

GCNameDailyDetail.propTypes = {
    t: PropTypes.any,
};


export default GCNameDailyDetail;
